import React from 'react';
import PropTypes from 'prop-types';

import { MainWrapper, WrapperBox, Contact, StyledContact } from './style';

const SummaryProfile = ({
  className,
  dataUser,
  dataSocial,
  clickSocialEditIcon
}) => (
  <MainWrapper className={className}>
    <WrapperBox>
      {/* <BoxSummary>
        {title && <Title>{title}</Title>}
        <BoxEmpty />
      </BoxSummary> */}
      {(dataUser || dataSocial) && (
        <StyledContact className="contact">
          <Contact
            dataUser={dataUser}
            dataSocial={dataSocial}
            onClick={clickSocialEditIcon}
          />
        </StyledContact>
      )}
    </WrapperBox>
  </MainWrapper>
);

SummaryProfile.propTypes = {
  className: PropTypes.string,
  // title: PropTypes.string,
  dataUser: PropTypes.shape({
    extension: PropTypes.number,
    mobile: PropTypes.string,
    address: PropTypes.string
  }),
  dataSocial: PropTypes.shape({
    facebook: PropTypes.string,
    instagram: PropTypes.string,
    twitter: PropTypes.string,
    vimeo: PropTypes.string,
    linkedin: PropTypes.string
  }),
  clickSocialEditIcon: PropTypes.func
};

export default SummaryProfile;
